<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <app-file-upload (fileSelected)="handleFiles($event)" [multiple]="false"
                [extension]="['pdf']" [maxFiles]="maxFile" [maxFileSize]="maxFileSize"></app-file-upload>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-md-12 text-end">
            <button type="button" class="btn btn-info rounded-pill text-white" (click)="subirDocumentos()">
                <span class="fa fa-upload"></span>
                Subir Documentos</button>
        </div>
    </div>

    <app-paginacion *ngIf="currentItems.length > 0"
        [paginatedData]="currentItems" [headers]="tableHeaders" [actions]="customActions"
        [loading]="spinner" [paginator]="false">
    </app-paginacion>

</div>


<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Ver Documento</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <iframe *ngIf="documentPdfUrl" [src]="documentPdfUrl" width="100%" height="500px" frameborder="0"
            allowfullscreen></iframe>
        <div *ngIf="!documentPdfUrl" class="text-center p-4">
            Cargando documento o no hay documento para mostrar...
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('Cerrar click')">Cerrar</button>
    </div>
</ng-template>